/* =================================================================
   SENSE5 - Klang-Regler 2.3
   Ersetzt assets/music.js. Aussehen unveraendert (runde Scheibe aus
   plain-jane.css), geaendert ist nur das Verhalten:

   - Ton startet ausschliesslich nach einem Klick auf den Regler.
     Die alte Fassung hing play() an mousemove, mousedown, touchmove
     und mouseup und startete auf jeder weiteren Seite von selbst,
     sobald der Zeiger sich bewegte.
   - Der Zustand gilt nur fuer diese Sitzung (sessionStorage), nicht
     fuer alle kuenftigen Besuche.
   - Kein Schreiben auf document.documentElement.style.cursor.
   - Der Regler weicht dem Fussbereich aus, statt Links zu verdecken.
   ================================================================= */
(function () {
  'use strict';

  var KEY_ON = 's5.sound.on';
  var KEY_AT = 's5.sound.at';

  function store(k, v) { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }

  function init() {
    var box = document.querySelector('.music-container');
    if (!box || box.__booted) return;
    box.__booted = true;

    var audio = box.querySelector('audio');
    var btn = box.querySelector('#play, .s5-player__btn');
    var progress = box.querySelector('.progress');
    var cover = box.querySelector('#cover');
    var bar = document.getElementById('song-bar');
    var src = box.getAttribute('data-src') || '';
    if (!audio || !btn || !src) { box.style.display = 'none'; return; }

    audio.src = src;
    audio.loop = true;
    audio.preload = 'none';

    function setState(on) {
      /* .play ist die Klasse, an der plain-jane.css die Rotation der
         Scheibe und das Einfahren der Titelzeile haengt. */
      box.classList.toggle('play', on);
      box.classList.toggle('is-playing', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Ton aus' : 'Ton an');
      btn.title = on ? 'Ton aus' : 'Ton an';
    }

    function play() {
      var at = parseFloat(read(KEY_AT) || '0');
      if (at > 0 && isFinite(at)) { try { audio.currentTime = at; } catch (e) {} }
      var p = audio.play();
      if (p && p.catch) p.catch(function () { setState(false); store(KEY_ON, null); });
      setState(true);
      store(KEY_ON, '1');
    }

    function pause() {
      audio.pause();
      setState(false);
      store(KEY_ON, null);
    }

    function toggle(e) {
      if (e) e.preventDefault();
      if (audio.paused) play(); else pause();
    }

    btn.addEventListener('click', toggle);
    if (cover) cover.addEventListener('click', toggle);

    audio.addEventListener('timeupdate', function () {
      store(KEY_AT, String(audio.currentTime));
      if (progress && audio.duration) {
        progress.style.width = (audio.currentTime / audio.duration * 100).toFixed(2) + '%';
      }
    });
    audio.addEventListener('pause', function () { setState(false); });
    audio.addEventListener('play', function () { setState(true); });

    setState(false);

    /* Fortsetzen nur, wenn der Ton in DIESER Sitzung eingeschaltet war. */
    if (read(KEY_ON) === '1') play();

    /* Titelzeile beim Ueberfahren, wie zuvor. */
    if (bar) {
      var hideTimer;
      var show = function () { clearTimeout(hideTimer); bar.style.visibility = 'visible'; bar.classList.add('visible'); };
      var hide = function () {
        hideTimer = setTimeout(function () {
          bar.classList.remove('visible');
          setTimeout(function () { bar.style.visibility = 'hidden'; }, 300);
        }, 1600);
      };
      [cover, btn].forEach(function (el) {
        if (!el) return;
        el.addEventListener('mouseenter', show);
        el.addEventListener('mouseleave', hide);
      });
    }

    /* Der Regler weicht dem Fussbereich aus, statt Links zu verdecken. */
    var foot = document.querySelector('.theme-footer, .s5v2-footer, footer');
    if (foot && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { box.classList.toggle('is-tucked', en.isIntersecting); });
      }, { rootMargin: '0px 0px -20% 0px', threshold: 0.02 }).observe(foot);
    }

    /* Tastatur: M schaltet um, solange kein Feld fokussiert ist. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'm' && e.key !== 'M') return;
      var t = document.activeElement;
      if (t && /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      toggle();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
